import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { NewsletterDto } from '@shared/types';

export function useNewsletter() {
  return useMutation({
    mutationFn: (feedItemIds: string[]) =>
      api.post<{ data: NewsletterDto }>('/newsletter', { feedItemIds }),
  });
}
